// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"Slider-module--slider-wrapper--1U06M"};